"use strict";
export var TransactionOriginType = /* @__PURE__ */ ((TransactionOriginType2) => {
  TransactionOriginType2["Internal"] = "internal";
  TransactionOriginType2["External"] = "external";
  return TransactionOriginType2;
})(TransactionOriginType || {});
export var TransactionStatus = /* @__PURE__ */ ((TransactionStatus2) => {
  TransactionStatus2["Canceled"] = "cancelled";
  TransactionStatus2["Cancelling"] = "cancelling";
  TransactionStatus2["FailedCancel"] = "failedCancel";
  TransactionStatus2["Success"] = "confirmed";
  TransactionStatus2["Failed"] = "failed";
  TransactionStatus2["Pending"] = "pending";
  TransactionStatus2["Replacing"] = "replacing";
  TransactionStatus2["Expired"] = "expired";
  TransactionStatus2["InsufficientFunds"] = "insufficientFunds";
  TransactionStatus2["Unknown"] = "unknown";
  return TransactionStatus2;
})(TransactionStatus || {});
export var QueuedOrderStatus = /* @__PURE__ */ ((QueuedOrderStatus2) => {
  QueuedOrderStatus2["Waiting"] = "waiting";
  QueuedOrderStatus2["ApprovalFailed"] = "approvalFailed";
  QueuedOrderStatus2["WrapFailed"] = "wrapFailed";
  QueuedOrderStatus2["AppClosed"] = "appClosed";
  QueuedOrderStatus2["Stale"] = "stale";
  QueuedOrderStatus2["SubmissionFailed"] = "submissionFailed";
  QueuedOrderStatus2["Submitted"] = "submitted";
  return QueuedOrderStatus2;
})(QueuedOrderStatus || {});
export const TEMPORARY_TRANSACTION_STATUSES = [
  "pending" /* Pending */,
  "replacing" /* Replacing */,
  "cancelling" /* Cancelling */
];
const FINAL_STATUSES = [
  "confirmed" /* Success */,
  "failed" /* Failed */,
  "cancelled" /* Canceled */,
  "failedCancel" /* FailedCancel */,
  "expired" /* Expired */
];
export var NFTTradeType = /* @__PURE__ */ ((NFTTradeType2) => {
  NFTTradeType2["BUY"] = "buy";
  NFTTradeType2["SELL"] = "sell";
  return NFTTradeType2;
})(NFTTradeType || {});
export var TransactionType = /* @__PURE__ */ ((TransactionType2) => {
  TransactionType2["Approve"] = "approve";
  TransactionType2["Permit2Approve"] = "permit2-approve";
  TransactionType2["Bridge"] = "bridge";
  TransactionType2["Swap"] = "swap";
  TransactionType2["Wrap"] = "wrap";
  TransactionType2["NFTApprove"] = "nft-approve";
  TransactionType2["NFTTrade"] = "nft-trade";
  TransactionType2["NFTMint"] = "nft-mint";
  TransactionType2["Send"] = "send";
  TransactionType2["Receive"] = "receive";
  TransactionType2["FiatPurchaseDeprecated"] = "fiat-purchase";
  TransactionType2["LocalOnRamp"] = "local-onramp";
  TransactionType2["LocalOffRamp"] = "local-offramp";
  TransactionType2["OnRampPurchase"] = "onramp-purchase";
  TransactionType2["OnRampTransfer"] = "onramp-transfer";
  TransactionType2["OffRampSale"] = "offramp-sale";
  TransactionType2["WCConfirm"] = "wc-confirm";
  TransactionType2["Unknown"] = "unknown";
  TransactionType2["SendCalls"] = "send-calls";
  return TransactionType2;
})(TransactionType || {});
export function isConfirmedSwapTypeInfo(typeInfo) {
  return Boolean(
    typeInfo.inputCurrencyAmountRaw && typeInfo.outputCurrencyAmountRaw
  );
}
export function isBridgeTypeInfo(typeInfo) {
  return typeInfo.type === "bridge" /* Bridge */;
}
export function isFinalizedTxStatus(status) {
  return FINAL_STATUSES.some((finalStatus) => finalStatus === status);
}
export function isFinalizedTx(tx) {
  const validateFinalizedTx = () => {
    const { status, hash } = tx;
    if (status === "confirmed" /* Success */) {
      if (!hash) {
        return void 0;
      }
      return { ...tx, status, hash };
    } else if (isFinalizedTxStatus(status)) {
      return { ...tx, status };
    }
    return void 0;
  };
  return Boolean(validateFinalizedTx());
}
export var TransactionDetailsType = /* @__PURE__ */ ((TransactionDetailsType2) => {
  TransactionDetailsType2["Transaction"] = "TransactionDetails";
  TransactionDetailsType2["OnRamp"] = "OnRampTransactionDetails";
  TransactionDetailsType2["OffRamp"] = "OffRampTransactionDetails";
  TransactionDetailsType2["UniswapXOrder"] = "SwapOrderDetails";
  return TransactionDetailsType2;
})(TransactionDetailsType || {});
